import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useOrgDataStore from '@/stores/org-store';
import CreateAssessmentPage from '@/features/survey/pages/CreateAssessmentPage';
import CreatePresetAssessmentPage from '@/features/survey/pages/CreatePresetAssessmentPage';

export const CreateAssessmentRouter = () => {
  const navigate = useNavigate();
  const { selectedSchool } = useOrgDataStore();

  // Check if selected school has preset indicators
  const hasPresetIndicators = selectedSchool?.presetIndicators && selectedSchool.presetIndicators.length > 0;

  // If no school is selected, redirect to assessment list
  useEffect(() => {
    if (!selectedSchool) {
      navigate('/assessment');
    }
  }, [selectedSchool, navigate]);

  // Show loading while checking
  if (!selectedSchool) {
    return null;
  }

  // Render the appropriate component based on preset indicators
  return hasPresetIndicators ? <CreatePresetAssessmentPage /> : <CreateAssessmentPage />;
};
